import E404 from "./E404";
export default E404;
